import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import Mensagem from '../../Mensagens';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class FaleConosco extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"fale-conosco"} image={"fale-conosco"} items={null} /></ErrorBoundary>

				{/* Page description */}
				{/* <ErrorBoundary><PageDescriptionContato page={"fale-conosco"} /></ErrorBoundary> */}
				{/* Content page */}
				<br></br><br></br>
				<ErrorBoundary><Mensagem /></ErrorBoundary>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default FaleConosco;